import {ReviewsStateType} from '../../page/main/reviews/reviews-state/reviews-state-type';
import {serializeToURLParameters} from '../../util/api-adapter';
import {fetchX} from '../../util/fetch';
import {objectToUrlParameters} from '../../util/url';
import {rootApiUrl} from '../api/api-const';

import {reviewsStateFilterToUrlObject} from './reviews-helper';

export enum ExportReportModeEnum {
    Base = 'base',
    Base1 = 'base1',
    Base2 = 'base2',
    Base3 = 'base3',
    Base4 = 'base4',
    Base5 = 'base5',
}

export type CommentsLayoutType = 'rows' | 'columns';

export type ExportReportOptionsType = {
    mode: ExportReportModeEnum;
    customReportName: string;
    withReviewsSummary?: boolean;
    withTagsStat?: boolean;
    version?: number;
    additionalUserEmails?: string;
    commentsLayout?: CommentsLayoutType;
};

export function fetchReviewsGetReport(
    reportOptions: ExportReportOptionsType,
    reviewOption: ReviewsStateType,
    mainFilterKey: string
): Promise<void> {
    const {additionalUserEmails, ...restReportOptions} = reportOptions;

    const serializedOptions =
        serializeToURLParameters<Omit<ExportReportOptionsType, 'additionalUserEmails'>>(restReportOptions);
    const filterParameters = reviewsStateFilterToUrlObject(reviewOption);

    const allParameters: Record<string, string | number | boolean> = {
        ...serializedOptions,
        ...filterParameters,
        ...(!reviewOption.company_ids ? {filter_key: mainFilterKey} : {}),
        timestamp: Date.now(),
    };

    if (additionalUserEmails && additionalUserEmails.trim()) {
        allParameters.additional_user_emails = additionalUserEmails;
    }

    const searchParameters = objectToUrlParameters(allParameters);

    return fetchX<void>(`${rootApiUrl}/v4/reviews/export/?${searchParameters}`);
}
